import { Routes, Route, useLocation } from "react-router-dom";
import React from "react";
import HomePage from "./pages/HomePage";
import HowItWorksPage from "./pages/HowItWorksPage";
import ServicesPage from "./pages/ServicesPage";
import PricingPage from "./pages/PricingPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import RulesPage from "./pages/RulesPage";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import StickyMobileCTA from "./components/StickyMobileCTA";
import WhatsAppButton from "./components/WhatsAppButton";


const ScrollToTop = () => {
    const { pathname } = useLocation();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export const AdPage = ({ isSign }: { isSign: boolean }) => {
    return (
        <div className="flex flex-col min-h-screen">
            <ScrollToTop />
            <Navbar isSign={isSign} />
            <main className="flex-grow">
                <Routes>
                    <Route index element={<HomePage />} />
                    <Route path="how-it-works" element={<HowItWorksPage />} />
                    <Route path="services" element={<ServicesPage />} />
                    <Route path="pricing" element={<PricingPage />} />
                    <Route path="faq" element={<FAQPage />} />
                    <Route path="contact" element={<ContactPage />} />
                    <Route path="rules" element={<RulesPage />} />
                    {/* Fallback route */}
                    <Route path="*" element={<HomePage />} />
                </Routes>
            </main>
            <Footer />
            <StickyMobileCTA />
            <WhatsAppButton />
        </div>
    );
}
